<template>
  <div class="ficha-blog container" v-if="!!data">
    <router-link to="/blog" class="btn-arrow-left" v-if="data.successes == '0'">{{
      $t("blog.volverBlog")
    }}</router-link>
     <router-link to="/casos-de-exito" class="btn-arrow-left" v-if="data.successes == '1'">
      Volver a casos de éxito</router-link>
    <div class="head">
      <h1 class="title">{{ data.title }} </h1>
      <p class="date">{{ currentDateTime(data.updated_at) }}</p>
      <div
        class="img"
        :style="`background-image:url(` + data.header_img.url + `)`"
        :title="data.header_img_subtitle"
      ></div>
    </div>
    <div class="content">
      <editorjs :object="data.description"></editorjs>
      <div class="share-box d-flex justify-content-end">
        <span class="title">{{ $t("blog.compartir") }} :</span>
        <a
          :href="`http://www.facebook.com/sharer.php?u=${url}&t=${data.title}`"
          target="_blank"
          ><span class="fa fa-facebook"></span
        ></a>

        <a
          :href="
            `https://www.linkedin.com/shareArticle?mini=false&url=${url}&title=${data.title}`
          "
          target="_blank"
          ><span class="fa fa-linkedin"></span
        ></a>
        <a
          :href="
            `http://twitter.com/intent/tweet?text=${data.title}&url=${url}`
          "
          target="_blank"
          ><span class="fa fa-twitter"></span
        ></a>
      </div>
    </div>
    <section class="articles-relacionated">
      <p class="title" v-if="data.successes == '0'">{{ $t("blog.ultimasNoticias") }}</p>
      <p class="title" v-if="data.successes == '1'">Últimos casos de éxito</p>
      <div class="all-entries">
        <last-noticias :success="data.successes" :titlenoticia="data.title"></last-noticias>
      </div>
    </section>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import lastNoticias from "@/components/views/ultimas-noticias-blog.vue";
import editorjs from "@/components/views/editorjs";
import moment from "moment";
export default {
  name: "ficha-noticia",
  mounted() {
    this.getData();
  },
  data: () => ({
    data: ""
  }),
  methods: {
    currentDateTime(date) {
      return moment(date)
        .locale("es")
        .format("LL");
    },
    ...mapActions(["requestNoticiaSlug"]),
    getData() {
      this.requestNoticiaSlug(this.$route.params.id).then(r => {
        if (r) {
          this.data = r;
          // document.title = (this.data.seoTitle) ? this.data.seoTitle : this.data.titulo;
          // document.head.querySelector("[name=description]").content = (this.data.seoDescription) ? this.data.seoDescription : this.data.entradilla.split(0, 100);

          // if (this.data.img.crop) {
          //     document.head.querySelector("[property='og:image']").content = this.data.img.crop;
          //     document.head.querySelector("[name='twitter:image']").content = this.data.img.crop;
          // }

          // document.head.querySelector("[property='og:title']").content = (!this.data.seoTitle) ? this.data.seoTitle : this.data.titulo;
          // document.head.querySelector("[name='twitter:title']").content = (this.data.seoTitle) ? this.data.seoTitle : this.data.titulo
          // document.head.querySelector("[name='twitter:site']").content = location.href;
          // document.head.querySelector("[property='og:description']").content = (this.data.seoDescription) ? this.data.seoDescription : this.data.entradilla.split(0, 100);
          // document.head.querySelector("[name='twitter:description']").content = (this.data.seoDescription) ? this.data.seoDescription : this.data.entradilla.split(0, 100);
        }
      });
    }
  },
  computed: {
    url() {
      return location.href;
    }
  },
  components: {
    editorjs: editorjs,
    "last-noticias": lastNoticias
  },
  filters: {
    urlToID(value) {
      let string;

      if (value.includes("youtube")) {
        string = "https://www.youtube.com/embed/" + value.split("?v=")[1];
      } else if (value.includes("vimeo")) {
        string = "https://player.vimeo.com/video/" + value.split("/").pop();
      }

      return string;
    }
  },
  watch: {
    "$route.params.id"() {
      this.getData();
    }
   
  }
};
</script>
<style>
.ficha-noticia .slider-imagenes .slide {
  padding: 0 20px;
}
.ficha-noticia .slider-imagenes .slide img {
  max-width: 100%;
}
.ficha-noticia .slick-dots {
  bottom: -50px;
  left: 0;
  list-style: none;
}
.ficha-noticia .slick-dots li {
  list-style: none;
  width: auto;
}
.btn-rounded-blue{
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/views/ficha-blog.vue